(() => {
  if (customElements.get('mimsy-announcement-ticker')) return;
  class MimsyAnnouncementTicker extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.sync = () => {
        const stationary = this.dataset.autoplay !== 'true' || this.motionPreference.matches;
        const paused = this.contains(document.activeElement) || document.hidden;
        this.dataset.state = stationary ? 'static' : paused ? 'paused' : 'running';
      };
      const options = { signal: this.abort.signal };
      document.addEventListener('visibilitychange', this.sync, options);
      this.motionPreference.addEventListener('change', this.sync, options);
      this.addEventListener('focusin', this.sync, options);
      this.addEventListener('focusout', () => queueMicrotask(() => {
        if (this.isConnected) this.sync();
      }), options);
      this.sync();
    }
    disconnectedCallback() {
      this.abort?.abort();
    }
  }
  customElements.define('mimsy-announcement-ticker', MimsyAnnouncementTicker);
})();
